import RNBluetoothClassic from "react-native-bluetooth-classic";
import * as SecureStore from "expo-secure-store";
import { getStorage, MERCHANT_BRAND_KEY, removeStorage, setStorage } from "./storageService";

import {
  getPendingOrders,
  markOrderPrinting,
  markOrderPrinted,
  markOrderFailed,
} from "./orderQueueService";
import { buildReceipt } from "./receiptBuilder";
import AsyncStorage from "@react-native-async-storage/async-storage";
//import { markOrderFailed } from "./orderQueueService";

const PRINTER_KEY = "merchantPrinter";

let currentPrinter = null;

let reconnectTimeout = null;

let healthCheckInterval = null;

let reconnectRunning = false;

let retryIndex = 0;

const RETRY_DELAYS = [2000, 4000, 8000, 15000];

const HEALTH_CHECK_INTERVAL = 10000; //10 seconds

/**
 * Get all paired Bluetooth printers/devices
 */
export async function getPairedPrinters() {
  try {
    const devices = await RNBluetoothClassic.getBondedDevices();

    return devices || [];
  } catch (error) {
    console.log("Find printer error:", error);
    return [];
  }
}

/**
 * Save selected printer
 */
export async function savePrinter(printer) {
  try {
    await setStorage(
      "merchantPrinter",
      JSON.stringify({
        name: printer.name,
        address: printer.address,
      }),
    );

    console.log("Printer saved");
  } catch (error) {
    console.log("Save printer error:", error);
  }
}

/**
 * Get saved printer information
 */
export async function getSavedPrinter() {
  try {
    // const printer = await SecureStore.getItemAsync(PRINTER_KEY);
    const printer = await getStorage("merchantPrinter");

    if (!printer) return null;

    return JSON.parse(printer);
  } catch (error) {
    console.log("Get saved printer error:", error);

    return null;
  }
}

/**
 * Remove saved printer
 */
export async function removeSavedPrinter() {
  try {
    // await SecureStore.deleteItemAsync(PRINTER_KEY);
    await removeStorage(PRINTER_KEY);

    currentPrinter = null;
  } catch (error) {
    console.log(error);
  }
}

/**
 * Connect to a printer selected from the UI
 */
export async function connectPrinter(printer) {
  try {
    const connected = await printer.connect();

    if (connected) {
      currentPrinter = printer;

      console.log("Printer connected");

      return true;
    }

    return false;
  } catch (error) {
    console.log("Connect printer error:", error);

    return false;
  }
}

/**
 * Automatically reconnect to saved printer
 */
export async function connectSavedPrinter() {
  if (reconnectRunning) return;

  reconnectRunning = true;

  try {
    const savedPrinter = await getSavedPrinter();

    if (!savedPrinter) {
      console.log("No saved printer");

      reconnectRunning = false;

      return;
    }

    const printers = await getPairedPrinters();

    const printer = printers.find((p) => p.address === savedPrinter.address);

    if (!printer) {
      console.log("Saved printer not found");

      scheduleReconnect();

      return;
    }

    const connected = await printer.connect();

    if (!connected) {
      scheduleReconnect();

      return;
    }

    currentPrinter = printer;

    retryIndex = 0;

    reconnectRunning = false;

    console.log("Printer connected");

    startPrinterHealthCheck();
  } catch (error) {
    console.log("Auto connect error:", error);

    scheduleReconnect();
  }
}
// export async function connectSavedPrinter() {
//   try {
//     const savedPrinter = await getSavedPrinter();

//     if (!savedPrinter) {
//       console.log("No printer saved");

//       return false;
//     }

//     const printers = await getPairedPrinters();

//     const printer = printers.find((p) => p.address === savedPrinter.address);

//     if (!printer) {
//       console.log("Saved printer not found");

//       return false;
//     }

//     const connected = await printer.connect();

//     if (connected) {
//       currentPrinter = printer;

//       console.log("Auto connected");

//       return true;
//     }

//     return false;
//   } catch (error) {
//     console.log("Auto connect error:", error);

//     return false;
//   }
// }

function scheduleReconnect() {
  reconnectRunning = false;

  stopPrinterHealthCheck();

  const delay = RETRY_DELAYS[Math.min(retryIndex, RETRY_DELAYS.length - 1)];

  console.log(`Retrying in ${delay / 1000} seconds`);

  retryIndex++;

  clearTimeout(reconnectTimeout);

  reconnectTimeout = setTimeout(() => {
    connectSavedPrinter();
  }, delay);
}

function startPrinterHealthCheck() {
  if (healthCheckInterval) return;

  healthCheckInterval = setInterval(async () => {
    try {
      if (!currentPrinter) {
        stopPrinterHealthCheck();

        connectSavedPrinter();

        return;
      }

      const connected = await currentPrinter.isConnected();

      if (!connected) {
        console.log("Printer disconnected");

        currentPrinter = null;

        retryIndex = 0;

        stopPrinterHealthCheck();

        connectSavedPrinter();
      }
    } catch (error) {
      console.log("Health check failed");

      currentPrinter = null;

      retryIndex = 0;

      stopPrinterHealthCheck();

      connectSavedPrinter();
    }
  }, HEALTH_CHECK_INTERVAL);
}

function stopPrinterHealthCheck() {
  if (healthCheckInterval) {
    clearInterval(healthCheckInterval);

    healthCheckInterval = null;
  }
}

/**
 * Get active printer
 */
export function getCurrentPrinter() {
  return currentPrinter;
}

/**
 * Check connection
 */
export async function isPrinterConnected() {
  try {
    if (!currentPrinter) return false;

    return await currentPrinter.isConnected();
  } catch (error) {
    return false;
  }
}

/**
 * Disconnect printer
 */
export async function disconnectPrinter() {
  try {
    if (!currentPrinter) return;

    await currentPrinter.disconnect();

    currentPrinter = null;

    console.log("Printer disconnected");
  } catch (error) {
    console.log(error);
  }
}

/**
 * Print any receipt string
 */
// export async function print(receipt) {
//   try {
//     if (!currentPrinter) {
//       throw new Error("Printer not connected");
//     }

//     const connected = await currentPrinter.isConnected();

//     if (!connected) {
//       throw new Error("Printer disconnected");
//     }

//     await currentPrinter.write(receipt);

//     console.log("Receipt printed");

//     return true;
//   } catch (error) {
//     console.log("Print error:", error);

//     return false;
//   }
// }

export async function print(receipt) {
  try {
    // Check current connection
    if (currentPrinter) {
      const connected = await currentPrinter.isConnected();

      if (connected) {
        await currentPrinter.write(receipt);

        console.log("Receipt printed");

        return true;
      }
    }

    // Printer disconnected
    console.log("Printer disconnected. Trying reconnect...");

    const reconnected = await connectSavedPrinter();

    if (!reconnected) {
      console.log("Could not reconnect printer");

      return false;
    }

    // Retry print
    if (currentPrinter) {
      await currentPrinter.write(receipt);

      console.log("Receipt printed after reconnect");

      return true;
    }

    return false;
  } catch (error) {
    console.log("Print failed:", error);

    // Last retry attempt

    try {
      const retry = await connectSavedPrinter();

      if (retry && currentPrinter) {
        await currentPrinter.write(receipt);

        console.log("Receipt printed on retry");

        return true;
      }
    } catch (err) {
      console.log("Retry failed:", err);
    }

    return false;
  }
}

/**
 * Print sample receipt
 */
export async function printTest() {
  const receipt = `
        MEEZA

----------------------------

      TEST RECEIPT

----------------------------

Printer Connected

Hello Nightclub

----------------------------



`;

  return await print(receipt);
}

async function getBrandData() {
  const savedBrand = await AsyncStorage.getItem(MERCHANT_BRAND_KEY);
  return savedBrand ? JSON.parse(savedBrand) : { brandName: "MEEZA" };
}

/**
 * Print ALL orders (batches) of a table as one receipt
 */
export async function printTableOrders(table) {
  const orders = (table.orders || []).filter((o) => o.status !== "cancelled");
  if (orders.length === 0) return false;

  // Merge identical items across batches
  const merged = {};
  orders.forEach((batch) => {
    (batch.items || []).forEach((it) => {
      const key = `${it.name}-${it.menuType ?? ""}`;
      if (!merged[key]) {
        merged[key] = { ...it, quantity: 0, totalItemPrice: 0 };
      }
      merged[key].quantity += it.quantity || 0;
      merged[key].totalItemPrice += Number(it.totalItemPrice ?? 0);
    });
  });

  const allPaid = orders.every((o) => o.status === "paid");
  const amount = orders.reduce((sum, o) => sum + (o.orderTotalAmount || 0), 0);

  // Same shape buildReceipt already expects from your queue payload
  const combinedOrder = {
    orderID: `TABLE-${table._id}-${Date.now()}`,
    tableID: table._id,
    tableNumber: String(table.tableNumber ?? ""),
    tableName: table.tableName,
    waiterName: table.waiterID?.waiterName,
    items: Object.values(merged),
    amount,
    isPayLater: !allPaid,
    paidAt: allPaid ? new Date().toISOString() : null,
  };

  const brandData = await getBrandData();
  const receipt = buildReceipt(combinedOrder, brandData);

  return await print(receipt);
}

/**
 * Print real receipt
 */
export async function printReceipt(printer, order) {
  const savedBrand = await AsyncStorage.getItem(MERCHANT_BRAND_KEY);

  const brandData = savedBrand
    ? JSON.parse(savedBrand)
    : {
        brandName: "MEEZA",
      };

  const receipt1 = `

        MEEZA

----------------------

TABLE:

${order.tableID}


ITEMS

${order.items
  .map(
    (item) =>
      `${item.quantity} x ${item.name}
₦${item.totalItemPrice}

`,
  )
  .join("")}



----------------------

TOTAL:

₦${order.amount}


----------------------


Thank you


\n\n\n

`;
  const receipt = buildReceipt(order, brandData);

  await printer.write(receipt);
}

export async function checkPrinterStatus() {
  try {
    if (!currentPrinter) {
      return false;
    }

    return await currentPrinter.isConnected();
  } catch (error) {
    return false;
  }
}

let workerRunning = false;

/**
 * Start printer worker
 */
export function startPrinterWorker() {
  if (workerRunning) {
    console.log("Printer worker already running");

    return;
  }

  workerRunning = true;

  console.log("🖨 Printer worker started");

  runPrinterWorker();
}

async function runPrinterWorker() {
  while (workerRunning) {
    try {
      const orders = getPendingOrders();

      if (orders.length === 0) {
        await sleep(3000);

        continue;
      }

      const order = orders[0];

      console.log("Printing order:", order.orderID);

      await processOrder(order);
    } catch (error) {
      console.log("Printer worker error:", error);
    }

    await sleep(2000);
  }
}

async function processOrder(order) {
  try {
    const printer = getCurrentPrinter();

    if (!printer) {
      console.log("No printer connected");

      return;
    }

    const connected = await printer.isConnected();

    if (!connected) {
      console.log("Printer disconnected");

      return;
    }

    markOrderPrinting(order.orderID);

    const orderData = JSON.parse(order.payload);

    await printReceipt(printer, orderData);

    markOrderPrinted(order.orderID);

    console.log("Printed:", order.orderID);
  } catch (error) {
    console.log("Print failed:", error);

    markOrderFailed(order.orderID);
  }
}

/**
 * Stop background print worker
 */
export function stopPrinterWorker() {
  console.log("Stopping printer worker...");

  workerRunning = false;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// import RNBluetoothClassic from "react-native-bluetooth-classic";

// export async function getPairedPrinters() {
//   try {
//     const devices = await RNBluetoothClassic.getBondedDevices();

//     return devices;
//   } catch (error) {
//     console.log("Find printer error:", error);

//     return [];
//   }
// }

// export async function connectPrinter(printer) {
//   try {
//     const connected = await printer.connect();

//     const status = await printer.isConnected();

//     console.log("Connected:", connected, "Status:", status);

//     return status;
//   } catch (error) {
//     console.log(error);

//     return false;
//   }
// }

// export async function printTest(printer) {
//   try {
//     const isConnected = await printer.isConnected();

//     console.log("Printer status:", isConnected);

//     if (!isConnected) {
//       console.log("Printer not connected");

//       return;
//     }

//     const receipt = `
//         MEEZA

// --------------------

//       TEST PRINT

//  Printer Connected

// --------------------

//  Hello Nightclub

// \n\n\n
// `;

//     await printer.write(receipt);

//     console.log("Print command sent");
//   } catch (error) {
//     console.log("Print error:", error);
//   }
// }
